import { Injectable } from '@angular/core';
import { ApiService, } from './api.service';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'

import { DashboardData } from '../models/index';
import { SelectItem } from '../../shared/models/index';

import { getSingleResponse, updateResponse } from './api.service';

import { ConfirmationService } from 'primeng/primeng';
import { MessageService } from 'primeng/components/common/messageservice';

@Injectable()
export class DashboardService extends ApiService<DashboardData> {

	protected apiName: string = 'dashboard';

	constructor(
		public http: HttpClient,
		public translate: TranslateService,
		public confirmationService: ConfirmationService,
		public messageService: MessageService
	) {
		super(http, translate, confirmationService, messageService);
	}

	/**
	 * get(id)
	 * Retrieve single object
	 */
	get(): Observable<getSingleResponse<DashboardData>> {
		return this.http.get<getSingleResponse<DashboardData>>(
			this.getBaseUrl('get')
		).retry(this.retries);
	}

}



// WEBPACK FOOTER //
// /var/www/vhosts/s-wines.nl/httpdocs/crm/resources/assets/src/app/shared/services/dashboard.service.ts